import Vue from 'vue'
import Router from 'vue-router'
import headTop from "@/components/common/header/head"; 
Vue.component('head-top',headTop); 

const Home = resolve => require(['@/components/Home'],resolve);
const Search = resolve => require(['@/components/Search'],resolve);
const Invite = resolve => require(['@/components/invite'],resolve)                          // 我的邀请
const List = resolve => require(['@/components/List'],resolve);

const myMail =  resolve => require(['@/components/MyMail'],resolve);                        // 我的邮箱 
const Scan =  resolve => require(['@/components/Scan'],resolve);                            // 扫码 
const Survey =  resolve => require(['@/components/Survey'],resolve);                      // 问卷调查 参与投票 
const Pers = resolve => require(['@/components/Pers'],resolve);                             // 个人中心首页

const BInfo1 = resolve => require(['@/components/bsInfo/BInfo1'],resolve)                           // 基本信息
const BInfo2 = resolve => require(['@/components/bsInfo/BInfo2'],resolve)                           // 我的关注
const BInfo3 = resolve => require(['@/components/bsInfo/BInfo3'],resolve)                           // 我的下载
const BInfo4 = resolve => require(['@/components/bsInfo/BInfo4'],resolve)                           // 我的医生
const modify = resolve => require(['@/components/bsInfo/children/modify'],resolve)                  // 修改

const baseComplete = resolve => require(['@/components/baseComplete'],resolve)              // 完善基本信息
const baseDoctors = resolve => require(['@/components/baseDoctors'],resolve)                // 完善基本信息医生
const doctors = resolve => require(['@/components/doctors'],resolve)                        // 医生信息 

const detail = resolve => require(['@/components/detail'],resolve)                          // 详情 (ppt 和 视频)

Vue.use(Router);

const routers = new Router({
  //mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/', 
      redirect:'/home'
    },{
      path: '/home',
      component:Home
    },{
      path:'/search/:searchId',
      component:Search
    },{
      path:'/pers',
      component:Pers,
      children:[{
        path:'bs',
        component:BInfo1,
        children:[{
          path:':edit',
          component:modify
        }]
      },{
        path:'myatten',
        component:BInfo2,
      },{
        path:'mydownload',
        component:BInfo3
      },{
        path:'mydoc',
        component:Invite,
        children:[{
          path:'userid/:uid',
          component:doctors,
            children:[{
            path:':edit',
            component:modify
          }]
        }] 
      }]
    },
    {
      path:'/mymail/:informationId',
      component:myMail
    },{
      path:'/baseComplete',
      component:baseComplete
    },{
      path:'/baseDoctors', 
      component:baseDoctors
    },{
        path:'/scan',
        component:Scan
    },{
      path:'/dep/:dep/:id',
      component:List
    },{
      path:'/detail/:vid',
       component:detail
    },{
      path: '/ppt/:vid', 
      redirect:'/detail/:vid'
    },{
      path:'/vdetail/:vid',
      redirect:'/detail/:vid'
    },
    {
      path:'/Survey/:mid/:sid',
      component:Survey 
    }
  ]
});
export default routers;


// WEBPACK FOOTER //
// ./src/router/index.js